module.exports = __webpack_public_path__ + "img/data-item3-2.93892f5.png";